/**
 * Alpine.js + Livewire 3 ESM Bundle
 *
 * This file imports Livewire and Alpine from the ESM build,
 * registers all Alpine plugins, and starts Livewire.
 *
 * IMPORTANT: inject_assets is set to false in config/livewire.php,
 * so this bundle is the sole source of Livewire + Alpine JS.
 * Layouts must include @livewireScriptConfig before this script.
 *
 * NOTE: Livewire 3 ESM already bundles these official Alpine plugins:
 *   persist, intersect, collapse, anchor, morph, focus, mask, resize
 * Do NOT register them again — it causes "Cannot redefine property" errors.
 * Only register third-party plugins here (tooltip, clipboard, etc.).
 */

import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

// Third-party Alpine plugins (NOT bundled in Livewire ESM)
import Tooltip from '@ryangjchandler/alpine-tooltip';
import Clipboard from '@ryangjchandler/alpine-clipboard';

Alpine.plugin(Tooltip);
Alpine.plugin(Clipboard);

// Expose Alpine globally (needed for inline Alpine.data() in Blade templates)
window.Alpine = Alpine;

// Start Livewire (which also starts Alpine)
Livewire.start();
